<script setup lang="ts">
import type { IFileState } from "@/interfaces";

interface Props {
  file: IFileState;
  customStyles?: string;
}

withDefaults(defineProps<Props>(), {
  customStyles: "min-w-160 w-160 h-160 min-h-160 rounded-2xl",
});

defineEmits<{ click: [] }>();
</script>

<template>
  <button
    type="button"
    class="overflow-hidden block hover:scale-105 transition-transform px-4"
    :class="[customStyles]"
    :style="{
      backgroundImage: `url(${file.base64 || file.url})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }"
    @click="$emit('click')"
  ></button>
  <div
    class="hidden group-hover:flex absolute left-0 top-0 bg-black h-full opacity-20 w-full justify-end py-2 px-2 rounded-2xl cursor-pointer"
    @click="$emit('click')"
  ></div>
</template>
